import { Carrot, Layers, Package, UtensilsCrossed } from "lucide-react"

import { SectionSidebarLayout } from "./SectionSidebarLayout"

export function CatalogSectionLayout() {
  return (
    <SectionSidebarLayout
      navId="catalog"
      navItems={[
        { icon: UtensilsCrossed, label: "Menu", to: "/catalog/menu" },
        { icon: Carrot, label: "Ingredients", to: "/catalog/ingredients" },
        { icon: Package, label: "Packaging", to: "/catalog/packaging" },
        { icon: Layers, label: "Kits", to: "/catalog/kits" },
      ]}
    />
  )
}
